/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobLoggerRequest {
    getFixupPrototypeFunction() { return BackgroundJobLoggerRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobLoggerRequest>): BackgroundJobLoggerRequest {
        let obj = Object.assign(new BackgroundJobLoggerRequest(), model);
        BackgroundJobLoggerRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobLoggerRequest>): BackgroundJobLoggerRequest {
        if (!model) return null;
        return BackgroundJobLoggerRequest.newInstance(<BackgroundJobLoggerRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobLoggerRequest) {
        if (!obj) return;

        models.BackgroundJobLoggerRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobLoggerRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobLoggerRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Filter to loggers in this executor
     */
    executor: models.BackgroundJobExecutor;

}
